import { useState } from "react";

import {
  dismissTourCard,
  isTourCardDismissed,
  isTourCompleted,
} from "../../lib/onboarding";
import { Button } from "../ui/button";
import { useTour } from "./tourContext";

// Dismissible "Take a tour" prompt shown on the dashboard after the first-run
// wizard (L0-U10 session 2). Never auto-starts the tour — it only offers it.
// Hidden once the tour is completed/skipped or the card is dismissed; the tour
// stays re-launchable from Settings either way.
export function TourCard() {
  const { startTour } = useTour();
  const [hidden, setHidden] = useState(
    () => isTourCompleted() || isTourCardDismissed(),
  );

  if (hidden) return null;

  return (
    <div
      data-testid="tour-card"
      className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-outline-variant bg-surface-container-low p-4"
    >
      <div className="min-w-0">
        <p className="font-display text-base font-medium tracking-tight text-on-surface">
          New here? Take a quick tour
        </p>
        <p className="mt-0.5 text-sm text-on-surface-variant">
          A 60-second walkthrough of the main surfaces. You can re-launch it any
          time from Settings.
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button
          type="button"
          variant="ghost"
          onClick={() => {
            dismissTourCard();
            setHidden(true);
          }}
        >
          Maybe later
        </Button>
        <Button
          type="button"
          onClick={() => {
            startTour();
          }}
        >
          Take a tour
        </Button>
      </div>
    </div>
  );
}
